import { Box, BoxProps, ButtonBase, styled } from "@mui/material";

export interface StyledPreviewImageBoxProps extends BoxProps {
  backgroundImage: string;
  onClick?: () => void;
}

export const StyledPreviewImageBox = styled(ButtonBase, {
  shouldForwardProp: prop => prop !== "backgroundImage"
})<StyledPreviewImageBoxProps>(({ theme, backgroundImage }) => ({
  backgroundImage,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",

  width: "100%",
  height: "100%",
  display: "block",
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",

  // Remove default button styles
  border: 0,
  padding: 0,

  "&:focus-visible": {
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}`
  },

  "&:hover": {
    opacity: 0.95
  },

  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.08)",
    opacity: 0,
    transition: "opacity 0.2s ease",
    pointerEvents: "none"
  },

  "&:hover::after": {
    opacity: 1
  }
}));

// --- Internal Styled Component to fix resolution error ---
export const StyledPreviewImageBoxInternal = styled(Box, {
  shouldForwardProp: prop => prop !== "backgroundImage"
})<{ backgroundImage: string }>(({ backgroundImage }) => ({
  width: "100%",
  height: "100%",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundImage: backgroundImage,
  cursor: "pointer",
  borderRadius: 1,
  transition: "transform 0.3s ease-in-out",
  "&:hover": {
    transform: "scale(1.05)",
    opacity: 0.85
  }
}));
